module.exports = __webpack_public_path__ + "img/person.4005a2aa.png";